export default {
    search_action_placeholder: "Search action...",
    search_client_placeholder: "Search client...",
    search_placeholder: "Search...",
    close: "Close",
    cancel: "Cancel",
    apply: "Apply",
    select: "Select",
    select_client: "Select client",
    select_branches: "Select branches",
    client_no_registration: "Unregistered client",
    all: "All",
    enter_dates: "Enter dates",
    enter_values: "Enter values",
    up_to: "Up to {0}",
    after: "After {0}",
    from: "From {0}",
    between: "Between {0} and {1}",
    not_informed: "Not informed",
    restrict_time_range: "Restrict time range",
    days_ago_title: "Days ago",
    period_days_ago: "Period: {0} days ago.",
    more_than: "More than {0}",
    date_picker: {
        days_of_week: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        months: [
            "Jan", "Feb", "Mar", "Apr", "May", "Jun",
            "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
        ],
    },
    ranges: {
        today: "Today",
        yesterday: "Yesterday",
        this_month: "This month",
        this_year: "This year",
        last_month: "Last month",
        last_year: "Last year",
        all_period: "All period",
    },
    last_12_months: "Last 12 months",
    last_3_months: "Last 3 months",
    last_x_days: "Last {0} days",
    min: "Minimum",
    max: "Maximum",
};
